import { render } from "./SubProjectDependencies.vue?vue&type=template&id=cc677946&scoped=true"
import script from "./SubProjectDependencies.vue?vue&type=script&lang=js"
export * from "./SubProjectDependencies.vue?vue&type=script&lang=js"

import "./SubProjectDependencies.vue?vue&type=style&index=0&id=cc677946&lang=css"
import "./SubProjectDependencies.vue?vue&type=style&index=1&id=cc677946&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cc677946"]])

export default __exports__